import httpClient from './httpClient';
import {handleError} from '../utils/errorHandling';

export interface ContactRequest {
  name: string;
  email: string;
  title: string;
  content: string;
  captchaToken: string;
}

class ContactService {
  public async submitContactForm(request: ContactRequest): Promise<void> {
    return handleError(
      async () => await httpClient.post<void>('/contact', request),
      'Error submitting contact form:'
    );
  }
}

const contactService = new ContactService();
export default contactService;

